import './styles/global.css';
import Navbar from './layouts/Navbar';
import Footer from './layouts/Footer';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard/Dashboard';
import ServiceDetail from './pages/ServiceDetail';
import AllReviews from './pages/AllReviews';

const SERVICE_SLUGS = ['website-development', 'ai-ml-solutions', 'research-technical'];

export default function App() {
  const path = window.location.pathname;

  if (path.startsWith('/dashboard')) return <Dashboard />;

  if (path === '/reviews') return (
    <>
      <Navbar />
      <AllReviews />
      <Footer />
    </>
  );

  const slug = SERVICE_SLUGS.find(s => path === `/services/${s}`);
  if (slug) return (
    <>
      <Navbar />
      <ServiceDetail slug={slug} />
      <Footer />
    </>
  );

  return (
    <>
      <Navbar />
      <main><Home /></main>
      <Footer />
    </>
  );
}
